export default "__VITE_ASSET___6K8jhwf__"